(()=>{
'use strict';
const qs=(s,r=document)=>r.querySelector(s);
const qsa=(s,r=document)=>[...r.querySelectorAll(s)];
const header=qs('.fq-header');
let toastTimer;
function toast(message){const node=qs('#fqToast');if(!node)return;node.textContent=message;node.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(()=>node.hidden=true,2800)}
function bindHeader(){
 const menu=qs('[data-fq-menu]'),panel=qs('#fqMobileNav'),search=qs('[data-fq-search]'),sPanel=qs('#fqSearchPanel');
 menu?.addEventListener('click',()=>{const opening=panel.hidden;panel.hidden=!opening;menu.setAttribute('aria-expanded',String(opening));if(opening&&sPanel){sPanel.hidden=true;search?.setAttribute('aria-expanded','false')}});
 search?.addEventListener('click',()=>{const opening=sPanel.hidden;sPanel.hidden=!opening;search.setAttribute('aria-expanded',String(opening));if(opening){qs('input[type=search]',sPanel)?.focus();if(panel){panel.hidden=true;menu?.setAttribute('aria-expanded','false')}}});
 qsa('.fq-mobile-nav a').forEach(a=>a.addEventListener('click',()=>{panel.hidden=true;menu?.setAttribute('aria-expanded','false')}));
 document.addEventListener('keydown',e=>{if(e.key==='Escape'){if(sPanel)sPanel.hidden=true;if(panel)panel.hidden=true;search?.setAttribute('aria-expanded','false');menu?.setAttribute('aria-expanded','false');closeModal()}});
 document.addEventListener('click',e=>{if(header&&!header.contains(e.target)){if(panel)panel.hidden=true;if(sPanel)sPanel.hidden=true;menu?.setAttribute('aria-expanded','false');search?.setAttribute('aria-expanded','false')}});
}
function progress(){if(!header)return;let max=Math.max(document.documentElement.scrollHeight-window.innerHeight,1);header.style.setProperty('--fq-scroll',(100*window.scrollY/max).toFixed(1)+'%')}
function setupFilters(context=document){
 qsa('[data-fq-food-gallery], [data-fq-quotes]',context).forEach(root=>{
  if(root.dataset.fqBound==='true')return;
  root.dataset.fqBound='true';
  qsa('[data-fq-filter]',root).forEach(b=>b.addEventListener('click',()=>{
    const chosen=b.dataset.fqFilter;
    qsa('[data-fq-filter]',root).forEach(x=>{const active=x===b;x.classList.toggle('active',active);x.setAttribute('aria-pressed',String(active))});
    qsa('[data-category]',root).forEach(card=>{card.hidden=!(chosen==='all'||card.dataset.category===chosen)});
  }));
 });
}
let currentModal=null,lastFocused=null;
function closeModal(){if(!currentModal)return;currentModal.remove();currentModal=null;document.body.style.overflow='';lastFocused?.focus?.()}
function openModal(title,body,src){
 closeModal();lastFocused=document.activeElement;
 const outer=document.createElement('div');outer.className='fq-detail-backdrop';outer.setAttribute('role','presentation');
 const content=document.createElement('section');content.className='fq-detail-modal';content.setAttribute('role','dialog');content.setAttribute('aria-modal','true');content.setAttribute('aria-label',title||'Food and Quotes preview');
 const close=document.createElement('button');close.className='fq-modal-close';close.textContent='×';close.setAttribute('aria-label','Close preview');close.addEventListener('click',closeModal);
 content.appendChild(close);
 if(src){const img=document.createElement('img');img.src=src;img.alt=title||'Food and Quotes';img.loading='lazy';content.appendChild(img)}
 const copy=document.createElement('div');copy.className='fq-detail-copy';
 const h=document.createElement('h2');h.textContent=title||'Food & Quotes';copy.appendChild(h);
 const p=document.createElement('p');p.textContent=body||'Discover more in Food & Quotes.';copy.appendChild(p);
 const done=document.createElement('button');done.textContent='CLOSE PREVIEW ↗';done.addEventListener('click',closeModal);copy.appendChild(done);content.appendChild(copy);
 outer.appendChild(content);outer.addEventListener('click',event=>{if(event.target===outer)closeModal()});document.body.appendChild(outer);document.body.style.overflow='hidden';currentModal=outer;close.focus();
}
function bindDetails(){document.addEventListener('click',event=>{
 const detail=event.target.closest('[data-fq-detail]');
 if(detail){event.preventDefault();openModal(detail.dataset.detailTitle,detail.dataset.detailBody,detail.dataset.detailImage);return}
 const shareQuote=event.target.closest('[data-share-text]');
 if(shareQuote){event.preventDefault();shareText(shareQuote.dataset.shareText);return}
 const shareCurrent=event.target.closest('[data-fq-share-current]');if(shareCurrent){shareText(document.title+' '+window.location.href)}
});}
async function shareText(text){
 if(!text)return;
 try{if(navigator.share){await navigator.share({text});return}if(navigator.clipboard){await navigator.clipboard.writeText(text);toast('Copied to clipboard');return}}
 catch(e){if(e?.name==='AbortError')return}
 try{const field=document.createElement('textarea');field.value=text;document.body.appendChild(field);field.select();document.execCommand('copy');field.remove();toast('Copied to clipboard')}
 catch(e){toast('Select the quote text to share')}
}
let obs=null;
function setupReveal(context=document){
 const items=qsa('.fq-motion-target',context);
 if(!('IntersectionObserver' in window)){items.forEach(x=>x.classList.add('fq-in-view'));return}
 if(!obs)obs=new IntersectionObserver(entries=>entries.forEach(x=>{if(x.isIntersecting){x.target.classList.add('fq-in-view');obs.unobserve(x.target)}}),{rootMargin:'0px 0px -8% 0px',threshold:.04});
 items.forEach(x=>{if(!x.classList.contains('fq-in-view'))obs.observe(x)});
}
function init(){bindHeader();bindDetails();setupFilters();setupReveal();progress();window.addEventListener('scroll',progress,{passive:true});window.addEventListener('resize',progress,{passive:true});document.addEventListener('shopify:section:load',event=>{setupFilters(event.target);setupReveal(event.target)});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
(()=>{
 function initCalendars(scope=document){
  const calendars=scope.querySelectorAll('[data-fq-calendar]');
  for(const calendar of calendars){if(calendar.dataset.calendarInit)return;calendar.dataset.calendarInit='true';
   const title=calendar.querySelector('[data-fq-month]'),days=calendar.querySelector('[data-fq-calendar-days]');if(!title||!days)continue;
   const rows=[...calendar.parentElement.querySelectorAll('[data-fq-event-date]')];
   const events=new Map();
   for(const row of rows){const iso=row.dataset.fqEventDate;if(/^\d{4}-\d{2}-\d{2}$/.test(iso||'')){
     const p=iso.split('-').map(Number),valid=new Date(p[0],p[1]-1,p[2]);
     if(valid.getFullYear()===p[0]&&valid.getMonth()+1===p[1]&&valid.getDate()===p[2]){if(!events.has(iso))events.set(iso,[]);events.get(iso).push(row)}
   }}
   const now=new Date();let view=new Date(now.getFullYear(),now.getMonth(),1);
   const pad=n=>String(n).padStart(2,'0');
   const render=()=>{
    title.textContent=new Intl.DateTimeFormat(undefined,{month:'long',year:'numeric'}).format(view);
    days.replaceChildren();const first=new Date(view.getFullYear(),view.getMonth(),1),offset=(first.getDay()+6)%7;
    const start=new Date(first);start.setDate(1-offset);
    for(let i=0;i<42;i++){
      const date=new Date(start.getFullYear(),start.getMonth(),start.getDate()+i),iso=date.getFullYear()+'-'+pad(date.getMonth()+1)+'-'+pad(date.getDate());
      const b=document.createElement('button');b.type='button';b.className='fq-calendar-day';b.textContent=String(date.getDate());
      b.dataset.currentMonth=String(date.getMonth()===view.getMonth());b.dataset.today=String(date.toDateString()===now.toDateString());
      b.dataset.hasEvents=String(events.has(iso));b.disabled=!events.has(iso);
      if(events.has(iso)){b.title='View event on '+iso;b.addEventListener('click',()=>events.get(iso)[0].scrollIntoView({behavior:'smooth',block:'center'}))}
      days.appendChild(b);
    }
   };
   calendar.querySelector('[data-fq-calendar-prev]')?.addEventListener('click',()=>{view=new Date(view.getFullYear(),view.getMonth()-1,1);render()});
   calendar.querySelector('[data-fq-calendar-next]')?.addEventListener('click',()=>{view=new Date(view.getFullYear(),view.getMonth()+1,1);render()});
   calendar.querySelector('[data-fq-calendar-today]')?.addEventListener('click',()=>{view=new Date(now.getFullYear(),now.getMonth(),1);render()});
   render();
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initCalendars());else initCalendars();
 document.addEventListener('shopify:section:load',e=>initCalendars(e.target));
})();


/* Food & Quotes product gallery thumbnail and variant selection behaviors. */
(()=>{
  document.addEventListener('click', (event)=>{
    const button=event.target.closest('[data-fq-product-thumb]');
    if(!button)return;
    const gallery=button.closest('[data-fq-gallery]');
    const main=gallery?.querySelector('[data-fq-main-image]');
    if(!gallery||!main)return;
    const nextUrl=button.dataset.fqImageUrl;
    if(!nextUrl)return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src=nextUrl;
    main.alt=button.dataset.fqImageAlt||main.alt;
    gallery.querySelectorAll('[data-fq-product-thumb]').forEach(b=>{
      const active=b===button;
      b.classList.toggle('is-active',active);
      b.setAttribute('aria-pressed',String(active));
    });
  });
  document.addEventListener('change',(event)=>{
    const select=event.target.closest('[data-fq-variant-select]');
    if(!select)return;
    const area=select.closest('.fq-product-purchase');
    const option=select.selectedOptions[0];
    if(!area||!option)return;
    const price=area.querySelector('[data-fq-variant-price]');
    const compare=area.querySelector('[data-fq-compare-price]');
    if(price&&option.dataset.price)price.textContent=option.dataset.price;
    if(compare){
      compare.textContent=option.dataset.compare||'';
      compare.hidden=!option.dataset.compare;
    }
  });
})();
